/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = High
 *
 * 2 = Medium
 *
 * 3 = Low
 *
 * 4 = Urgent
 */
export enum PrinterCartrigeStatusEnum {
  High = 1,
  Medium = 2,
  Low = 3,
  Empty = 4,
  Unknown = 5
}
